<template>
  <section class="role-seat-section">
    <div class="role-seat-section__header">
      <h2 class="role-seat-section__label">
        {{ label }}
      </h2>
      <BittsTag color="neutral" :text="String(count)" />
    </div>
    <div class="role-seat-section__cards">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { BittsTag } from '@crossbeam/bitts';

defineProps<{
  label: string;
  count: number;
}>();
</script>

<style scoped lang="pcss">
@reference "../css/theme.css";
.role-seat-section {
  @apply mb-24;
}
.role-seat-section__header {
  @apply flex items-center gap-8 mb-12;
}
.role-seat-section__label {
  @apply text-neutral-text-strong text-lg font-bold;
}
.role-seat-section__cards {
  @apply flex flex-col items-stretch;
}
</style>
